import QuestionBreakdownReport from './QuestionsBreakdownReport';
import { useGetCumulativeAssignmentReportWithRetakesMutation } from '../../../../../../features/authentication/reportApiSlice';

const ClassRetakeReport = () => {
  const [getCumulativeAssignmentReportWithRetakes] = useGetCumulativeAssignmentReportWithRetakesMutation();

  var headerOptions = {
    reportTitle: 'Class Retake Report',
    showClassDropdown: true,
    showTeacherName: true,
    showStudentName: false,
    showClassName: false,
    isAllStudentReport: true,
    showRetryInfo: true,
    showTotalRow: true,
    showReportType: true,
    reportType: 'Assignment'
  };

  return (
    <QuestionBreakdownReport
      isRetakeReport={true}
      exportFileName='ClassRetakeReport'
      reportDataEndpoint={getCumulativeAssignmentReportWithRetakes}
      headerOptions={headerOptions}
      goBackOnError={true}
    />
  );
};

export default ClassRetakeReport;